import { render, staticRenderFns } from "./menu.component.vue?vue&type=template&id=3fcd7880&scoped=true&"
import script from "./menu.component.vue?vue&type=script&lang=ts&"
export * from "./menu.component.vue?vue&type=script&lang=ts&"
import style0 from "./menu.component.vue?vue&type=style&index=0&id=3fcd7880&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcd7880",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VTooltip})
